// The Capablity KEYS!
const KBGP = 'kbgp';
const KDNS = 'kdns';
const KPROXY = 'kproxy'; // still behind a perm
const KSNMPTRAP = 'ksnmptrap'; // only behind a perm
const KSYSLOG = 'ksyslog'; // only behind a perm
const RANGER = 'ranger';
const KTRAFFIC = 'ktraffic';

// Block from public!
const LIVESYNTH = 'livesynth';
const KPACKET = 'kpacket';
const KSQUEEGEE = 'ksqueegee';
const KMETA = 'kmeta';

// NOT YET but planned
const KSYNTH = 'ksynth';

const KDUMMY = 'kdummy';

// Defines the default configuration for each capability. When installing a capability, a new config object will be created with the args set in this map.
const CAPABILITIES_DEFAULT_CONFIGS = {
  [KDNS]: {
    args: {
      interface: 'any',
      fanoutCount: '4',
      enableCompression: true,
      promiscuous: false,
      sampleRate: 1
    }
  },
  [KPROXY]: {
    args: {
      host: '0.0.0.0',
      port: 9995,
      basePort: 40010,
      sflowAgentAddress: false,
      logLevel: 'info'
    }
  },
  [KSNMPTRAP]: {
    args: {}
  },
  [KTRAFFIC]: {
    args: {}
  },
  [KSYSLOG]: {
    args: {
      udpListenAddr: '0.0.0.0:514',
      tcpListenAddr: '0.0.0.0:514'
    }
  },
  [KSQUEEGEE]: {
    args: {}
  },
  [KSYNTH]: {
    args: {}
  },
  [KMETA]: {
    args: {}
  }
};

const CMD_ARGS_KPROXY_KEBAB_OBJ = ['proxyhttp', 'proxyhttpallow'];
const CMD_ARGS_KPROXY_KEBAB = ['-proxy-http', '-proxy-http-allow'];

const CAPABILITY_TITLES = {
  kbgp: 'BGP Proxy (AKA kbgp)',
  kdummy: 'Dummy Capability',
  kdns: 'DNS OTT Tap',
  kproxy: 'Flow Proxy',
  ksnmptrap: 'SNMP Trap Receiver',
  ksynth: 'Synthetics',
  ksyslog: 'Syslog Server',
  livesynth: 'Connectivity Test',
  ktraffic: 'Flow Proxy v2',
  ranger: 'SNMP/ST',
  ksqueegee: 'Device Configuration Sync',
  kmeta: 'Metadata Collector'
};

const CAPABILITY_DESCRIPTIONS = {
  kbgp: 'Proxy local iBGP Route Reflector Client session from multiple hosts and multiplex them securely to Kentik SaaS cluster',
  kdns: 'Upon installation on a DNS server, collect and export DNS Query Responses to match against Flow Telemetry for OTT detection',
  kproxy:
    'Deploy this Agent Capability as an on-prem relay to export Network Flow  Telemetry (Netflow5,9, SFlow, IPFIX) ' +
    'from multiple registered devices to Kentik: point flow exports from your devices to this Agent IP and it will ' +
    'multiplex flow records securely to your KentiK SaaS Cluster.',
  ksnmptrap: 'Receive SNMP Traps and securely transport them to Kentik',
  ksynth: 'Turns host into Kentik Synthetics Agent to perform Network, HTTP and DNS synthetic tests',
  ksyslog: 'Provides syslog server that transports logs to Kentik',
  ranger: 'Base layer of network visibility including up/down, interface stats, and hardware components',
  livesynth: 'Connectivity Test - Allows AI Advisor to run network tests (ping,trace) on demand',
  ktraffic: 'Next generation Flow Proxy - experimental',
  ksqueegee: 'Fetch and backup configuration from network devices',
  kmeta: 'Fetch metadata using custom collectors and updates custom dimensions/populators',
  kdummy: 'Test Capability'
};

const CLUSTER_HEALTH_STATE_HEALTHY = 'CLUSTER_HEALTH_STATE_HEALTHY';
const CLUSTER_HEALTH_STATE_UNHEALTHY = 'CLUSTER_HEALTH_STATE_UNHEALTHY';

const cluster_health_status_labels = {
  CLUSTER_HEALTH_STATE_HEALTHY: 'Healthy',
  CLUSTER_HEALTH_STATE_UNHEALTHY: 'Unhealthy'
};

const cluster_health_intents = {
  CLUSTER_HEALTH_STATE_HEALTHY: 'success',
  CLUSTER_HEALTH_STATE_UNHEALTHY: 'danger'
};

const SYNTHETICS = 'Synthetics';

const NOT_AUTHORIZED = 'Not Authorized';
const RUNNING = 'Running';
const DOWN = 'Down';
const DISABLED = 'Disabled';
const WARNING = 'Warning';
const UP = 'Up';
const PENDING = 'Pending';
const UNKNOWN = 'Unknown';

module.exports = {
  CMD_ARGS_KPROXY_KEBAB,
  CMD_ARGS_KPROXY_KEBAB_OBJ,
  AGENT_HEALTH: {
    AGENT_HEALTH_STATE_HEALTHY: 'AGENT_HEALTH_STATE_HEALTHY',
    AGENT_HEALTH_STATE_UNHEALTHY: 'AGENT_HEALTH_STATE_UNHEALTHY',
    AGENT_HEALTH_STATE_OFFLINE: 'AGENT_HEALTH_STATE_OFFLINE'
  },
  CAPABILITY_TITLES,
  CAPABILITY_DESCRIPTIONS,
  CAPABILITY_HEALTH: {
    CAPABILITY_HEALTH_STATE_HEALTHY: 'CAPABILITY_HEALTH_STATE_HEALTHY',
    CAPABILITY_HEALTH_STATE_UNHEALTHY: 'CAPABILITY_HEALTH_STATE_UNHEALTHY',
    CAPABILITY_HEALTH_STATE_DISABLED: 'CAPABILITY_HEALTH_STATE_DISABLED',
    CAPABILITY_HEALTH_STATE_UNSPECIFIED: 'CAPABILITY_HEALTH_STATE_UNSPECIFIED'
  },
  CAPABILITY_KEYS: {
    KBGP,
    KDNS,
    KDUMMY,
    KPROXY,
    KSNMPTRAP,
    KSYNTH,
    KSYSLOG,
    LIVESYNTH,
    KTRAFFIC,
    RANGER,
    KSQUEEGEE,
    KMETA
  },
  CLUSTER_HEALTH: {
    CLUSTER_HEALTH_STATE_HEALTHY,
    CLUSTER_HEALTH_STATE_UNHEALTHY
  },
  CLUSTER_HEALTH_LABELS: cluster_health_status_labels,
  CLUSTER_HEALTH_INTENTS: cluster_health_intents,
  GROUP_HEALTH: {
    GROUP_HEALTH_STATE_HEALTHY: 'GROUP_HEALTH_STATE_HEALTHY',
    GROUP_HEALTH_STATE_UNHEALTHY: 'GROUP_HEALTH_STATE_UNHEALTHY'
  },
  GROUP_ID_PREFIX: 'group:',
  Capabilities: {
    // maybe call Capability_Keys? replacing with above is good
    KBGP,
    KDNS,
    KDUMMY,
    KPROXY,
    KSNMPTRAP,
    KSYNTH,
    KSYSLOG,
    LIVESYNTH,
    RANGER,
    KTRAFFIC,
    SYNTHETICS,
    KSQUEEGEE,
    KMETA
  },
  Statuses: {
    NOT_AUTHORIZED,
    RUNNING,
    DISABLED,
    DOWN,
    WARNING,
    PENDING,
    UP,
    UNKNOWN
  },
  CAPABILITIES_DEFAULT_CONFIGS,
  CAPABILITIES_W_CONFIGS: [KDNS, KPROXY, KSYSLOG, KSNMPTRAP, KTRAFFIC, KSQUEEGEE, KSYNTH, KMETA],
  CAPABILITIES_CURRENTLY_AVAILABLE_TO_ALL: [RANGER, KDNS, LIVESYNTH], // KSNMPTRAP, KSYSLOG, KPROXY, KMETA, and KSQUEEGEE are added by permissions
  CAPABILITIES_CURRENTLY_PLANNED: [KBGP],
  CAPABILITIES_TO_ALWAYS_REMOVE_FROM_PUBLIC: [KPACKET], // UI only setting - do not even show these in the blocked list.
  ALWAYS_SUPPORTED_CAPABILITIES: [RANGER, KSYSLOG, KSNMPTRAP, KDUMMY, KSQUEEGEE, KSYNTH, KMETA], // These are distribution-agnostic so can be installed on any linux distribution
  UNIFIED_TESTED_CAPABILITIES: [KSYSLOG, KSNMPTRAP, KTRAFFIC, KDNS, KPROXY, KSQUEEGEE, KMETA] // These are the capabilities that are tested in the unified test suite - Pls do not assume all work!
};
